import React from 'react';

import EarnPageContent from 'components/dashboard/earn-content/EarnPageContent';

const DashboardEarnPage = () => <EarnPageContent />;

export default DashboardEarnPage;
